import {BelegDTO, UpdateBelegRequestDTO} from '../openapi/fakturierung-openapi';
import {DeepPartial} from '../types/deep-partial';


/**
 * Der PUT ist Vollersatz: Ein nicht uebergebenes Feld wird serverseitig geleert. Deshalb
 * bauen alle Aufrufer ihr Request-DTO ueber diese Funktion.
 */
export function createUpdateBelegRequest(
  beleg?: DeepPartial<BelegDTO>,
  overrides: Partial<UpdateBelegRequestDTO> = {},
): UpdateBelegRequestDTO {
  return {
    datum: beleg?.datum ?? '',
    leistungsdatum: beleg?.leistungsdatum ?? '',
    kundeId: beleg?.kundeId,
    kundeRevision: beleg?.kunde?.revision,
    vorlaufzeile: beleg?.vorlaufzeile,
    zahlungszielTage: beleg?.zahlungszielTage,
    bestellnummer: beleg?.bestellnummer,
    lieferantennummer: beleg?.lieferantennummer,
    vertragsnummer: beleg?.vertragsnummer,
    projektnummer: beleg?.projektnummer,
    leitwegId: beleg?.leitwegId,
    ...overrides,
  };
}
